export default __webpack_public_path__ + "static/media/O-032.483ac742.png";